import ListTemplate from "components/ListTemplate";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import Filters from "./Filters";
import { DotLabel } from "components/Dot";
import TagList from "components/Tag/TagList";
import { mapResponseToFilterValues, mapFilterValuesToInstruction } from "./helpers";
import { useLoaderData } from "react-router";

const PromoterListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.PromoterListFrontModel>();

  return <ListTemplate
    title={site.currentEnvironment.functionGroups.promoter.plural}
    filterSet="company_Promoter_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.Promoter.Paginated}
    getId={item => item.companyId}
    layout={{
      type: "table",
      columns: [{
        key: "name",
        header: RESX.GeneralLabels.Name,
        render: item => <a href={routes.company_Detail(item.companyId).absolute} className="table-main-link">{item.name}</a>,
        size: "2fr"
      }, {
        key: "city",
        header: RESX.Address.City,
        render: item => item.cityCountry,
        size: "2fr"
      }, {
        key: "financialRisk",
        header: RESX.Promoter.FinancialRisk,
        render: item => item.financialRiskLevel.value !== "unknown" && <DotLabel dotColor={item.financialRiskLevel.hexColor}>{item.financialRiskLevel.text}</DotLabel>,
        size: "1fr"
      }, {
        key: "tags",
        header: "",
        render: item => <TagList tags={item.tags} length="short" />,
        size: "fit-content(200px)"
      }]
    }}
    filters={<Filters initialTags={viewModel.tags} />}
    functions={{
      mapResponseToFilterValues,
      mapFilterValuesToInstruction
    }}
  />;
};

export default PromoterListApp;
